import { render } from "./product-list.vue?vue&type=template&id=9d897c48&scoped=true&ts=true"
import script from "./product-list.vue?vue&type=script&lang=ts"
export * from "./product-list.vue?vue&type=script&lang=ts"

import "./styles/product-list.scss?vue&type=style&index=0&id=9d897c48&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d897c48"]])

export default __exports__